import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { CheckboxFilterService } from '../../services/checkbox-filter.service';

@Component({
  selector: 'app-checkbox-select',
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="relative min-w-0 flex-1">
      <button
        type="button"
        class="comcast-select-trigger"
        [class.comcast-select-trigger--open]="isOpen()"
        [class.comcast-select-trigger--filled]="data.selectedValues.length > 0"
        [attr.aria-expanded]="isOpen()"
        aria-haspopup="listbox"
        (click)="toggle($event)"
      >
        <span class="min-w-0 truncate">{{ placeholderText }}</span>
        <mat-icon class="comcast-select-icon" aria-hidden="true">
          {{ isOpen() ? 'arrow_drop_up' : 'arrow_drop_down' }}
        </mat-icon>
      </button>

      @if (isOpen()) {
        <div
          class="comcast-select-panel !right-auto min-w-[220px]"
          [class.comcast-select-panel--open]="isOpen()"
          role="listbox"
          aria-multiselectable="true"
          (click)="$event.stopPropagation()"
        >
          <div class="comcast-select-options">
            <div
              class="comcast-select-option border-b border-gray-200"
              [class.comcast-select-option--selected]="
                data.root.value && !data.root.indeterminate
              "
              role="option"
              [attr.aria-selected]="data.root.value"
              (click)="toggleRoot()"
            >
              {{ data.root.attrs.label }}
            </div>
            @for (item of data.children; track $index) {
              <div
                class="comcast-select-option pl-6"
                [class.comcast-select-option--selected]="item.value"
                role="option"
                [attr.aria-selected]="item.value"
                (click)="item.value = !item.value"
              >
                {{ item.attrs.label }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  `,
})
export class CheckboxSelectComponent<T> {
  @Input({ required: true }) data: CheckboxFilterService<T>;

  @Input() placeholder?: string;

  @Input() name?: string;

  @Output() opened = new EventEmitter<void>();

  isOpen = signal(false);

  @HostListener('document:click')
  close(): void {
    this.isOpen.set(false);
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    const opening = !this.isOpen();
    this.isOpen.update((v) => !v);
    if (opening) this.opened.emit();
  }

  closeDropdown(): void {
    this.isOpen.set(false);
  }

  toggleRoot(): void {
    this.data.root.value = !this.data.root.value;
  }

  get placeholderText(): string {
    const text = this.placeholder || 'Records';
    if (this.data.selectedValues.length) {
      return `${text} (${this.data.selectedValues.length} applied)`;
    }
    return text;
  }
}
